import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcProductInputComponent } from './fc-product-input.component';


@NgModule({
  declarations: [
    FcProductInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcProductInputComponent
  ]
})
export class FcProductInputModule {}
